import { ProductionFigureThemeModeConfig } from './types';

const dark: ProductionFigureThemeModeConfig = {
  productionFigure: {
    normalButtonBGColor: '#505251',
    normalButtonBorderColor: '2px solid #267DAC',
    cardBGColor: ' #DADBDC',
    cardBorderColor: '2px double #267DAC',
    profileHeaderBGColor: '#505251',
    profileHeaderFontColor: 'white',
  },
};

export default dark;
